/* Array.prototype.sort proxy, but immutable */

function arraySort(array, ...rest) {
  return [...array].sort(...rest);
}

export default arraySort;
